/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Dropdown } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { DeleteNotification } from "../../../../redux/features/notifications/notificationActions";
import { successMessage } from "../../../../utlis/common";
import ThreeDotsIcon from "../../../../../_metronic/assets/images/ThreeDotsIcon";
import { KTIcon } from "../../../../../_metronic/helpers/components/KTIcon";
import { conFirmMessage } from "../../../../utlis/shared";
import { toAbsoluteUrl } from "../../../../../_metronic/helpers";
import { setOpenAnalyticsModal } from "../../../../redux/features/Analytics/analyticsSlice";
import { DeleteInventory } from "../../../../redux/features/inventory/inventoryAction";
import { setOpenEditInventoryModal } from "../../../../redux/features/inventory/inventorySlice";

type Props = {
  user: any;
};

const ActionCell: FC<Props> = ({ user }) => {
  const dispatch: any = useDispatch();
  const sharedActions = useSelector((state: any) => state.sharedActions);
  const location = useLocation();

  const isNotificationRoute = location.pathname.includes("/notifications");
  const isInventoryRoute = location.pathname.includes("/inventory");


  const handleDelete = (itemId) => {
    const values = {
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    };

    conFirmMessage(values).then((result) => {

      console.log(sharedActions, ">>> sharedActions")
      if (result.isConfirmed) {
        if (isNotificationRoute) {
          console.log(sharedActions?.selectedPage, " notification >>> selectedPage", user?.id)
          setTimeout(() => {
            dispatch(
              DeleteNotification({
                id: user?.id,
                selectedPage: sharedActions?.selectedPage || 1,
              })
            );
          }, 100);
        }
        else if (isInventoryRoute) {
          console.log(sharedActions?.selectedPage, " inventory >>> selectedPage", user?.id)
          setTimeout(() => {
            dispatch(
              DeleteInventory({
                id: user?.id,
                selectedPage: sharedActions?.selectedPage || 1,
              })
            );
          }, 100);
        }
      }
    });
  };

  const handleEdit = async (itemId) => {
    console.log(sharedActions, ">>> sharedActions");
    console.log('itemId >>> ', itemId);

    if (isInventoryRoute) {
      console.log(sharedActions?.selectedPage, " inventory >>> selectedPage", user?.id)
      await dispatch(setOpenEditInventoryModal(user));
    }
  };

  const openUserDetailsModal = () => {
    console.log(user, ">> openUserDetailsModal >>>>")
    dispatch(setOpenAnalyticsModal(user.orders || []))
  }


  return (
    <>
      <div className="d-flex align-items-center">
        <div className="menu-item me-4">
          <Dropdown className="verifiedOptions">
            <Dropdown.Toggle variant="default" id="dropdown-basic">
              <ThreeDotsIcon />
            </Dropdown.Toggle>

            <Dropdown.Menu>
              {(isNotificationRoute || isInventoryRoute) && (
                <Link
                  to="#"
                  className="menu-link px-3 btn justify-content-start btn-active-light-primary btn-sm"
                  onClick={async () => await handleDelete(user.id)}
                >
                  <KTIcon iconName="trash" className="fs-2 text-danger" /> Delete
                </Link>
              )}

              {isInventoryRoute && (
                <Link
                  to="#"
                  className="menu-link px-3 btn justify-content-start btn-active-light-primary btn-sm"
                  onClick={async () => {
                    await handleEdit(user.id)
                  }}
                >
                  <KTIcon iconName="pencil" className="fs-2 text-warning" /> Edit
                </Link>
              )}

              {!(isNotificationRoute || isInventoryRoute) && (
                <Link
                  to="#"
                  className="menu-link justify-content-start px-3 btn btn-active-light-primary btn-sm"
                  onClick={openUserDetailsModal}
                >
                  <KTIcon iconName="eye" className="fs-2" /> Details
                </Link>
              )}
            </Dropdown.Menu>


          </Dropdown>
        </div>
      </div>
    </>
  );
};

export { ActionCell };
